import classNames from 'classnames';
import { format } from 'date-fns';
import { Tag } from 'primereact/tag';
import { FaFacebook, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa6';

export const AppFooter = () => {
  const Year = format(new Date(), 'Y')

  return (
    <div className="w-full block sm:flex sm:justify-between justify-center pb-6 mt-4 px-6">
      <a className='mt-2 flex-order-1' href="https://wa.me/5511988812431" rel="noopener noreferrer" target="_blank" >
        <div className='flex text-center items-center gap-2 bg-green-500 hover:bg-green-600 text-white rounded-lg p-2'>
          <FaWhatsapp />
          <span>Contato alternativo</span>
        </div>
      </a>
      <span className="font-medium text-center sm:flex-order-2 flex-order-3 ml-2 block mt-2">@{Year} DiretoTech. Todos os direitos reservados</span>
      <div className='flex mt-2 justify-center sm:flex-order-3 flex-order-2'>
        <a href="https://wa.me/5511996383405" rel="noopener noreferrer" target="_blank" >
          <Tag
            pt={{
              root: classNames(
                'bg-green-500 hover:bg-green-600 w-10 h-10 text-xl',
                'rounded-full items-center justify-center flex',
                'text-white'
              )
            }}
          >
            <FaWhatsapp />
          </Tag>
        </a>
        <a href="https://www.facebook.com/direto.tecnologia" rel="noopener noreferrer" className='ml-2' target="_blank" >
          <Tag
            pt={{
              root: classNames(
                'bg-blue-600 hover:bg-blue-700 w-10 h-10 text-xl',
                'rounded-full items-center justify-center flex',
                'text-white'
              )
            }}
          >
            <FaFacebook />
          </Tag>
        </a>
        <a href="https://br.linkedin.com/company/diretotech?trk=affiliated-pages" rel="noopener noreferrer" className='ml-2' target="_blank" >
          <Tag
            pt={{
              root: classNames(
                'bg-sky-800 hover:bg-sky-900 w-10 h-10 text-xl',
                'rounded-md items-center justify-center flex',
                'text-white'
              )
            }}
          >
            <FaLinkedin />
          </Tag>
        </a>
        <a href="https://www.instagram.com/diretotech/" rel="noopener noreferrer" className='ml-2' target="_blank" >
          <Tag
            pt={{
              root: classNames(
                'w-10 h-10 text-xl',
                'rounded-full items-center justify-center flex',
                'text-white'
              )
            }}
            style={{ background: "linear-gradient(to bottom,#7c36ad 40%,#f90600,#f9d900)" }}
          >
            <FaInstagram />
          </Tag>
        </a>
      </div>
    </div>
  );
}
